﻿<table>
    <thead>
        <tr>
            <th *ngIf="showRowGlyph"></th>
            <th *ngFor="let column of getColumnKeys()" (click)="onColumnHeaderClick(column)">
                 {{ columns[column] }}{{getSortIconClass(column)}}
            </th>
            <th *ngIf="showAdd || showEdit || showCopy || showDelete || showView"></th>
        </tr>
    </thead>

    <tbody>
        <tr *ngIf="items.length === 0">
            <td [attr.colspan]="getColumnKeys().length + (showRowGlyph ? 1 : 0) + (showAdd || showEdit || showCopy || showDelete || showView ? 1 : 0)" class="no-records">
                No records found.
            </td>
        </tr>

        <ng-container *ngIf="items.length > 0">
            <tr *ngFor="let item of items" (click)="selectItem(item)" (dblclick)="onDoubleClick(item)" [class.isSelected]="isSelected(item)" [class.isHighlighted]="isHighlighted(item)">
                <td *ngIf="showRowGlyph" [title]="glyphTooltipColumn ? getColumnValue(item, glyphTooltipColumn) || '' : ''">
                    <i class="{{ getColumnValue(item, glyphColumn) }}"></i>
                </td>
                <td *ngFor="let column of getColumnKeys()" [title]="getColumnValue(item, column)">
                    <ng-container *ngIf="useSwitch && column === switchField; else textDisplay">
                        <label class="switch">
                            <input type="checkbox"
                                [checked]="getColumnValue(item, column)"
                                (change)="onSwitchToggle(item)" />

                            <span class="slider">
                                <span class="toggle-text">{{ getColumnValue(item, column) ? 'Yes' : 'No' }}</span>
                            </span>
                        </label>
                    </ng-container>
                    <ng-template #textDisplay>
                        {{ getColumnValue(item, column) }}
                    </ng-template>
                </td>

                <td *ngIf="showAdd || showEdit || showCopy || showDelete || showView" class="column-actions">
                    <button *ngIf="showAdd" class="grid-button add" (click)="triggerAdd(item)">
                        <i class="fas fa-plus"></i>
                    </button>
                    <button *ngIf="showCopy" class="grid-button edit" (click)="triggerCopy(item)">
                        <i class="fas fa-copy"></i>
                    </button>
                   <button *ngIf="showEdit" class="grid-button edit" (click)="triggerEdit(item)">
                        <i class="fas" [ngClass]="hasExpired(item) ? 'fa-eye' : 'fa-pen'"></i>
                    </button>
                    <button *ngIf="showDelete" class="grid-button delete" (click)="triggerDelete(item)">
                        <i class="fas" [ngClass]="deleteIconClass"></i>
                    </button>
                    <button *ngIf="showView" class="grid-button add" (click)="triggerView(item)">
                        <i class="fas fa-eye"></i>
                    </button>
                </td>
            </tr>
        </ng-container>
    </tbody>

    <tfoot>
        <tr>
            <td [attr.colspan]="getColumnKeys().length + (showRowGlyph ? 1 : 0) + (showAdd || showEdit || showCopy || showDelete || showView? 1 : 0)">
                <div class="table-footer-wrapper">
                    <div class="table-footer-content left">
                        Records: {{ paging.recordCount ? paging.recordCount : 0 }}
                    </div>
                    <div class="table-footer-content center">
                        <button class="button-backward" (click)="pagePrevious()">
                            <i class="fas fa-arrow-left"></i>
                        </button>
                        <input class="page-index" [attr.value]="getPageNumber()" readonly>
                        <button class="button-forward" (click)="pageNext()">
                            <i class="fas fa-arrow-right"></i>
                        </button>
                    </div>
                    <div class="table-footer-content right">
                        <select class="page-size" [(ngModel)]="paging.pageSize" (ngModelChange)="pageSizeChanged($event)">
                            <option value="1">1</option>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
            </td>
        </tr>
    </tfoot>
</table>
